// Fast Loader + Safe Fallback
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.body.classList.add("loaded");
  }, 400);
});

// Backup: se algo pesado atrasar, libera no load
window.addEventListener("load", () => {
  document.body.classList.add("loaded");
});


// ✅ Barra de navegação (Top Swiper Bar)
document.addEventListener("DOMContentLoaded", () => {
  const barraAnuncios = document.querySelector(".anuncios__header-text .swiper");

  if (barraAnuncios && typeof Swiper !== "undefined") {
    new Swiper(barraAnuncios, {
      speed: 400,
      autoplay: {
        delay: 7000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      loop: true,
    });
  }

  // ✅ Navbar scroll behavior (optimized)
  let lastScrollTop = 0;
  const navbar = document.querySelector(".navbar__header");
  const navbarHeader = navbar?.querySelector("header");

  if (navbar && navbarHeader) {
    window.addEventListener(
      "scroll",
      () => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;

        // Throttle heavy DOM changes
        if (currentScroll > lastScrollTop && currentScroll > 53) {
          navbar.style.top = "-52px";
          navbarHeader.style.borderRadius = "0";
        } else {
          navbar.style.top = "0";
          navbarHeader.style.borderRadius = "15px 15px 0 0";
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      },
      { passive: true }
    );
  }

  // ✅ Página produto adjustments
  const boxProduto = document.querySelector(".product__info-container");
  const variantWrapper = document.querySelector(".variant__wrapper-content");

  if (boxProduto && variantWrapper) {
    const aplicarPadding = () => {
      const hasChild = variantWrapper.querySelector("div");
      if (!hasChild) {
        variantWrapper.style.padding = "0";
      } else {
        variantWrapper.style.removeProperty("padding");
      }
    };

    aplicarPadding();

    // Observe only direct changes for better performance
    const observer = new MutationObserver(aplicarPadding);
    observer.observe(variantWrapper, {
      childList: true,
    });
  }
});


// Pitchbar - cards extras (mesmo padrao)
(function () {
  var pitchbar = document.querySelector(".car-selector .pitchbar");
  if (!pitchbar) return;
  if (pitchbar.querySelector("[data-extra-card]")) return;

  var cards = [
    {
      icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a10 10 0 0 1 0 20z" fill="#1F1F1F" stroke="none"></path></svg>',
      text: "Escuro por fora, claro por dentro"
    },
    {
      icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"></circle><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path></svg>',
      text: "Garantia Vitalícia"
    },
    {
      icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="16" height="12" rx="2"></rect><line x1="7" y1="9.5" x2="14" y2="15.5" stroke-width="3.2"></line><line x1="10.5" y1="12.5" x2="17.5" y2="6.5"></line><line x1="5" y1="12.5" x2="7.3" y2="14.8" stroke-width="1.5"></line><line x1="5" y1="15.5" x2="6.8" y2="17.3" stroke-width="1.5"></line></svg>',
      text: "Indicação de instalador"
    }
  ];

  cards.forEach(function (c) {
    var col = document.createElement("div");
    col.className = "col-12 col-lg-3 pitchbar-item d-flex";
    col.setAttribute("data-extra-card", "");
    col.innerHTML =
      '<div class="pitchbar-item__wrapper d-flex justify-content-center align-items-center flex-grow-1">' +
        '<div class="col-4 pitchbar-item__image d-flex justify-content-center align-items-center">' + c.icon + '</div>' +
        '<div class="col-8 pitchbar-item__text">' + c.text + '</div>' +
      '</div>';
    pitchbar.appendChild(col);
  });
})();


// Pitchbar - esteira automatica + arrasto (mobile + desktop)
(function () {
  var pitchbar = document.querySelector(".car-selector .pitchbar");
  if (!pitchbar) return;
  var rafId = null, cloned = false, paused = false, resumeTimer = null, pos = 0;

  function addClones() {
    if (cloned) return;
    Array.prototype.slice.call(pitchbar.children).forEach(function (it) {
      var c = it.cloneNode(true);
      c.setAttribute("data-marquee-clone", "");
      c.setAttribute("aria-hidden", "true");
      pitchbar.appendChild(c);
    });
    cloned = true;
  }

  function step() {
    if (!paused) {
      pos += 0.7;
      var half = pitchbar.scrollWidth / 2;
      if (half > 0 && pos >= half) pos -= half;
      pitchbar.scrollLeft = pos;
    } else {
      pos = pitchbar.scrollLeft;
    }
    rafId = requestAnimationFrame(step);
  }

  function pause() { paused = true; clearTimeout(resumeTimer); }
  function resumeSoon() { clearTimeout(resumeTimer); resumeTimer = setTimeout(function () { paused = false; }, 1200); }

  function start() {
    addClones();
    if (!rafId) rafId = requestAnimationFrame(step);
  }

  pitchbar.addEventListener("touchstart", pause, { passive: true });
  pitchbar.addEventListener("touchend", resumeSoon, { passive: true });
  pitchbar.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") pause(); });
  pitchbar.addEventListener("pointerup", function (e) { if (e.pointerType !== "mouse") resumeSoon(); });

  if (document.readyState === "complete") start();
  else window.addEventListener("load", start);
})();
